import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=3da85e2c&scoped=true&"
import script from "./Action.vue?vue&type=script&lang=ts&"
export * from "./Action.vue?vue&type=script&lang=ts&"
import style0 from "./Action.vue?vue&type=style&index=0&id=3da85e2c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da85e2c",
  null
  
)

export default component.exports